///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthReportsTabs {
    ALL,
    NEW,
    INSTALLED
}

export const REPORT_TABS = [
    GtthReportsTabs[GtthReportsTabs.ALL],
    GtthReportsTabs[GtthReportsTabs.NEW],
    GtthReportsTabs[GtthReportsTabs.INSTALLED]
];
